import { formatInTimeZone } from 'date-fns-tz';

/**
 * Deep-link to the host space calendar with optional space + day preselection.
 * SpaceCalendarPage reads `spaceId` and `date` (yyyy-MM-dd) from the query string.
 */
export function hostSpaceCalendarPath(
  spaceId: string,
  options?: { date?: string | null },
): string {
  const params = new URLSearchParams();
  params.set('spaceId', spaceId);
  const date = options?.date?.trim();
  if (date) {
    params.set('date', date);
  }
  return `/host/calendar?${params.toString()}`;
}

/** Calendar day key (yyyy-MM-dd) for a booking instant in the given IANA timezone. */
export function bookingCalendarDateKey(
  startTimeIso: string,
  timezone?: string | null,
): string {
  const raw = startTimeIso.trim();
  if (!raw) return '';

  const utc =
    raw.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(raw) ? new Date(raw) : new Date(`${raw}Z`);
  if (Number.isNaN(utc.getTime())) return '';

  const tz = timezone?.trim();
  if (tz) {
    return formatInTimeZone(utc, tz, 'yyyy-MM-dd');
  }

  const y = utc.getUTCFullYear();
  const m = String(utc.getUTCMonth() + 1).padStart(2, '0');
  const d = String(utc.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
